import { Card } from "@/components/ui/card";
import { Sparkles } from "lucide-react";

const eventTypes = [
  {
    emoji: "🧘",
    title: "Yoga & Movement",
    description: "Flow, stretch, breathe",
    color: "from-purple-500/20 to-purple-600/20",
  },
  {
    emoji: "🎉",
    title: "Social Gatherings",
    description: "Brunches, happy hours, meetups",
    color: "from-pink-500/20 to-pink-600/20",
  },
  {
    emoji: "🛍️",
    title: "Pop-Up Events",
    description: "Markets, workshops, specials",
    color: "from-amber-500/20 to-amber-600/20",
  },
  {
    emoji: "🧘‍♀️",
    title: "Meditation",
    description: "Sound baths, guided sessions",
    color: "from-teal-500/20 to-teal-600/20",
  },
  {
    emoji: "💪",
    title: "Fitness & Outdoor",
    description: "Hikes, boot camps, dance",
    color: "from-green-500/20 to-green-600/20",
  },
];

export const DemoEventTypes = () => {
  return (
    <Card className="p-5 bg-card/95 backdrop-blur-sm border-border/50">
      <div className="space-y-4">
        <div className="flex items-center gap-2 justify-center">
          <Sparkles className="w-5 h-5 text-primary" />
          <span className="text-sm font-medium text-muted-foreground">Free to join, with free and paid wellness events available</span>
        </div>
        
        <div className="grid grid-cols-2 gap-2">
          {eventTypes.slice(0, 4).map((type, index) => (
            <div 
              key={index}
              className={`p-3 rounded-xl bg-gradient-to-br ${type.color} border border-border/30 transition-transform hover:scale-[1.02]`}
            >
              <div className="text-2xl mb-1">{type.emoji}</div>
              <h4 className="text-sm font-semibold text-foreground">{type.title}</h4>
              <p className="text-xs text-muted-foreground">{type.description}</p>
            </div>
          ))}
        </div>
        
        {/* Fifth item spans full width */}
        <div 
          className={`p-3 rounded-xl bg-gradient-to-br ${eventTypes[4].color} border border-border/30`}
        >
          <div className="flex items-center gap-3">
            <div className="text-2xl">{eventTypes[4].emoji}</div>
            <div>
              <h4 className="text-sm font-semibold text-foreground">{eventTypes[4].title}</h4>
              <p className="text-xs text-muted-foreground">{eventTypes[4].description}</p>
            </div>
          </div>
        </div>
        
        <p className="text-center text-xs text-muted-foreground">
          New events added weekly from local hosts
        </p>
      </div>
    </Card>
  );
};
